export const readFile = <T extends File>(file: T) => new Promise<Blob>(resolve => {
	const reader = new FileReader();
	reader.onabort = () => console.log('file reading was aborted');
	reader.onerror = () => console.log('file reading has failed');
	reader.onload = () => {
		const blob = new Blob(
			[reader.result as ArrayBuffer],
			{ type: file.type },
		);
		resolve(blob);
	};
	reader.readAsArrayBuffer(file);
});
